type Props = {
  width?: string;
  height?: string;
  color?: string;
};

const GearIcon = (props: Props) => {
  const { width = '12', height = '12', color = '#848484' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7.875C7.03553 7.875 7.875 7.03553 7.875 6C7.875 4.96447 7.03553 4.125 6 4.125C4.96447 4.125 4.125 4.96447 4.125 6C4.125 7.03553 4.96447 7.875 6 7.875Z"
        stroke={color}
        strokeWidth="0.673615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.94225 8.34672C1.73505 7.98983 1.57631 7.60693 1.47021 7.20813L2.25678 6.22375C2.24787 6.07326 2.24787 5.92237 2.25678 5.77188L1.47068 4.7875C1.57659 4.38863 1.73501 4.00559 1.94178 3.64844L3.19381 3.50781C3.29379 3.39517 3.40038 3.28857 3.51303 3.18859L3.65365 1.93703C4.0103 1.73125 4.39271 1.57378 4.79084 1.46875L5.77522 2.25531C5.92571 2.24641 6.0766 2.24641 6.22709 2.25531L7.21147 1.46922C7.61034 1.57513 7.99337 1.73354 8.35053 1.94031L8.49115 3.19234C8.6038 3.29232 8.71039 3.39892 8.81037 3.51156L10.0619 3.65219C10.2691 4.00908 10.4279 4.39198 10.534 4.79078L9.7474 5.77516C9.75631 5.92565 9.75631 6.07654 9.7474 6.22703L10.5335 7.21141C10.4283 7.61016 10.2707 7.99319 10.0647 8.35047L8.81272 8.49109C8.71274 8.60374 8.60614 8.71033 8.4935 8.81031L8.35287 10.0619C7.99598 10.2691 7.61308 10.4278 7.21428 10.5339L6.2299 9.74734C6.07941 9.75625 5.92852 9.75625 5.77803 9.74734L4.79365 10.5334C4.3949 10.4283 4.01187 10.2706 3.65459 10.0647L3.51397 8.81266C3.40132 8.71268 3.29473 8.60608 3.19475 8.49344L1.94225 8.34672Z"
        stroke={color}
        strokeWidth="0.673615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GearIcon;
